import gql from 'graphql-tag';

export default gql`
  query libraryProjectsAndLists($institutionId: ID!) {
    libraryProjectsAndLists(institutionId: $institutionId) {
      project {
        id
        state
        name
        id
        name
        createdAt
        goal
        suggestionsListId
        invitedBookshop {
          name
        }
        requirements {
          budget
        }
      }
      suggestionsList {
        id
        state
        acceptedSuggestionsCount
        rejectedSuggestionsCount
        suggestionsCount
        acceptedSuggestionsTotalCost {
          currency
          value
        }
        suggestionsTotalCost {
          currency
          value
        }
        rejectedSuggestionsTotalCost {
          currency
          value
        }
      }
    }
  }
`;
